// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2UkcX","title":"BackImages_title__2nSRD","images":"BackImages_images__1-q6_"};